import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ImageQueryService {
	transform(src: string, params: { width: number; height: number }): string {
		if (!src) {
			return '';
		} else if (src.includes('assets.vandervalkonline.com')) {
			return `${src}&w=${params.width}&h=${params.height}&fmt=webp`;
		}
		return `${src}?io=transform:fill,width:${params.width},height:${params.height}&format=webp&quality=70`;
	}
}
